import type * as React from "react"

import { buttonVariants, type ButtonProps } from "@/components/ui/button"
import { InfoTip } from "@/components/ui/tooltip"
import { cn } from "@/lib/utils"

/**
 * Кнопка из образца, за которой в этой сборке нет действия (`New rule`,
 * `Manage categories`, `View settings`, `Add Filter`).
 *
 * Не `<button disabled>`, а `<span aria-disabled>`: подсказка обязана
 * открываться по наведению, а на выключенной кнопке браузер не отдаёт события
 * указателя — пользователь видел бы серую кнопку без объяснения и считал бы её
 * поломкой. Причина написана прямым текстом в подсказке.
 */
export function Inactive({
  children,
  reason,
  size = "md",
  variant = "default",
  className,
}: {
  children: React.ReactNode
  reason: string
  size?: ButtonProps["size"]
  variant?: ButtonProps["variant"]
  className?: string
}) {
  return (
    <InfoTip label={reason}>
      <span
        role="button"
        aria-disabled
        tabIndex={0}
        className={cn(
          buttonVariants({ variant, size }),
          "cursor-not-allowed opacity-45",
          className,
        )}
      >
        {children}
      </span>
    </InfoTip>
  )
}
